import { gql } from "graphql-tag";

export const getNewsSubscriptionV2 = pageType => gql`
  fragment ${pageType}_news_subscription_v2 on ${pageType}SlicesNews_subscription_v2 {
    type
    label
    variation {
      ... on ${pageType}SlicesNews_subscription_v2Default {
         primary {
            title
            paragraph
            button_label
            email_input_placeholder
            button_color
            checkbox_label
            background_color
         }
      }
   }
 }`;
